import { createElement, useCallback, useContext } from 'react'
import { getAsideActionGlobalRef } from '~/components/Scopes/Actions/Global/asideActionRef'
import type { Action } from '~/domains/actions/types'
import type { AsideActionPosition } from '~/types/global'
import { AsideActionContext } from '~/utils/contextes'
import { TaskAside } from '../components/TaskAside/TaskAside'

type OpenTaskAsideOptions = {
  position?: AsideActionPosition
  availablePositions?: AsideActionPosition[]
  /** Use the legacy global aside instead of the React context (defaults to legacy pages detection). */
  legacy?: boolean
}

export const useOpenTaskAside = () => {
  const { setAsideAction } = useContext(AsideActionContext)

  return useCallback(
    (task: Action | number, options: OpenTaskAsideOptions = {}) => {
      const taskId = typeof task === 'number' ? task : task.id
      const action = createElement(TaskAside, { taskId })
      const legacy = options.legacy ?? window.JobConfig !== undefined
      if (legacy) {
        getAsideActionGlobalRef().current(action, {
          isWide: false,
          position: options.position ?? 'sidebar',
          availablePositions: options.availablePositions ?? ['sidebar']
        })
        return
      }
      setAsideAction({
        action,
        position: options.position,
        availablePositions: options.availablePositions
      })
    },
    [setAsideAction]
  )
}
